import {get, isString} from "lodash";
import {isNull, yesNoFilter} from "@/utils/formatting";

export default {
    methods: {
        showFieldsDataAsArray(fields, data, fieldsDefinitions) {
            const objectData = this.showFieldsData(fields, data, fieldsDefinitions);
            const dataArray = [];
            for (let i = 0; i < fields.length; i++) {
                let fieldLabel = fields[i];
                if (!isString(fields[i])) {
                    fieldLabel = fields[i].label;
                }
                if (objectData.hasOwnProperty(fieldLabel)) {
                    dataArray.push(objectData[fieldLabel]);
                }
            }
            return dataArray;
        },
        showFieldsData(fields, data, fieldsDefinitions) {
            let displayedFields = {};
            for (let i = 0; i < fields.length; i++) {
                let fieldLabel = fields[i];
                let helpTextAsUnit = null;
                if (!isString(fields[i])) {
                    fieldLabel = fields[i].label;
                    if (fields[i].hasOwnProperty('helpTextAsUnit')) {
                        helpTextAsUnit = fields[i].helpTextAsUnit;
                    }
                }
                const content = this.getFieldContent(fieldLabel, data, fieldsDefinitions, helpTextAsUnit);
                if (content !== '') {
                    displayedFields[fieldLabel] = {
                        label: this.getFieldLabel(fieldLabel, fieldsDefinitions),
                        value: content,
                    };
                }
            }
            return displayedFields;
        },
        getFieldLabel(field, fieldsDefinitions) {
            if (Array.isArray(field)) {
                return fieldsDefinitions[field[0]].label;
            }
            return fieldsDefinitions[field].label;
        },
        getFieldContent(fieldData, data, fieldsDefinitions, helpTextAsUnit = false) {
            let value;
            let field;
            if (Array.isArray(fieldData)) {
                value = get(data, fieldData[1]);
                field = fieldData[0];
            } else {
                value = data[fieldData];
                field = fieldData;
            }
            if (isNull(value)) {
                return '';
            }
            if (fieldsDefinitions[field].type === 'choice') {
                for (let choice in fieldsDefinitions[field].choices) {
                    if (fieldsDefinitions[field].choices[choice].value === data[field]) {
                        return fieldsDefinitions[field].choices[choice].display_name;
                    }
                }
            }
            if (fieldsDefinitions[field].type === 'multiple choice') {
                const multipleDisplayed = [];
                value.forEach(multipleChoiceSelected => {
                    for (const choice in fieldsDefinitions[field].choices) {
                        if (fieldsDefinitions[field].choices[choice].value === multipleChoiceSelected) {
                            multipleDisplayed.push(fieldsDefinitions[field].choices[choice].display_name);
                        }
                    }
                });
                return multipleDisplayed.join(', ');
            }
            if (fieldsDefinitions[field].type === 'date') {
                const date = new Date(value);
                return  date.toLocaleString('es', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                });
            }
            if (fieldsDefinitions[field].type === 'datetime') {
                const date = new Date(value);
                return date.toLocaleString('es', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                });
            }
            if (fieldsDefinitions[field].type === 'list') {
                return value.join(', ');
            }
            if (fieldsDefinitions[field].type === 'boolean') {
                return this.$t(yesNoFilter(data[field]));
            }
            if (fieldsDefinitions[field].type === 'float') {
                let representation = value.toString();
                if (helpTextAsUnit && fieldsDefinitions[field].hasOwnProperty('help_text')) {
                    representation = representation.concat(' ',fieldsDefinitions[field].help_text);
                }
                return representation;
            }
            return value;
        },
    },
};